import React, { Component } from 'react'
import { Formik } from 'formik'
import { injectIntl, FormattedMessage } from 'react-intl'
import {
  DisabledField,
  RoleField,
  PlantField,
  Buttons,
  FeatureFlagField,
  OrganisationTypeField,
  MakeField,
} from './Fields'

import { Flex, Typography } from 'antd'
import { Loadable } from '../Loading'

const { Title } = Typography

class EditUser extends Component {
  requestUserEdition = (formValues) => {
    const { updateUser } = this.props
    const userData = {
      role: formValues.role,
      plant: formValues.plant,
      disabled: formValues.disabled,
      feature_flag: formValues.feature_flag,
      organisation_type: formValues.organisation_type ?? '',
    }
    updateUser(userData)
  }

  validateForm = (values) => {
    const errors = {}
    if (!values.role || values.role.length === 0) {
      errors.role = 'Required'
    }

    if (!errors.role && !values.plant) {
      errors.plant = 'Required'
    }
    return errors
  }

  render() {
    const {
      customAttributes,
      externalProvider,
      isSaving,
      isLoading,
      editingUser,
      user,
    } = this.props

    const { roles, plants, feature_flags, organisation_types, makes } =
      customAttributes

    const manageableRoles = user.data.managable_roles
    const roleOptions = roles.map((role) => ({ value: role, label: role }))
    const plantOptions = plants.map((plant) => ({ value: plant, label: plant }))
    const featureFlagOptions = feature_flags.map((feature_flag) => ({
      value: feature_flag,
      label: feature_flag,
    }))
    const organisationTypeOptions = organisation_types.map(
      (organisation_type) => ({
        value: organisation_type,
        label: organisation_type,
      }),
    )
    const disabledOptions = [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ]
    const selectedPlants = editingUser.plants.map((plant) => plant)
    const selectedFeatureFlags = editingUser.feature_flags.map(
      (feature_flag) => feature_flag,
    )
    const selectedOrganisationType = editingUser.organisation_type
    const selectedMake = editingUser.makes.map((make) => make)
    /* We have restricted a user from editing other users' with higher privileges */
    const editRights =
      manageableRoles.filter((role) => {
        return role === editingUser.role
      }).length > 0

    const initialValues = {
      role: editingUser.role,
      plant: selectedPlants,
      feature_flag: selectedFeatureFlags,
      organisation_type: selectedOrganisationType,
      make: selectedMake,
      disabled: editingUser.disabled,
    }
    if (isLoading) {
      return <Loadable isLoading={true} showText={true} />
    }

    return (
      <Flex id="user-form-container" vertical={true} align="center" gap="small">
        <Title level={2}>
          <FormattedMessage id="users.editUser" /> {editingUser.email}
        </Title>
        <Formik initialValues={initialValues} validate={this.validateForm}>
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
            dirty,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Flex vertical={true} gap="middle">
                  <RoleField
                    options={roleOptions}
                    value={values.role}
                    onChange={(option) => setFieldValue('role', option)}
                    error={touched.role && errors.role}
                    disabled={!editRights}
                  />

                  <PlantField
                    role={values.role}
                    options={plantOptions}
                    onChange={(option) => setFieldValue('plant', option)}
                    value={values.plant}
                    error={touched.role && errors.plant}
                    disabled={!editRights}
                  />

                  <FeatureFlagField
                    options={featureFlagOptions}
                    onChange={(option) => setFieldValue('feature_flag', option)}
                    value={values.feature_flag}
                    error={touched.feature_flag && errors.feature_flag}
                    hidden={externalProvider}
                    disabled={!editRights || externalProvider}
                  />

                  <OrganisationTypeField
                    options={organisationTypeOptions}
                    value={values.organisation_type}
                    onChange={(option) =>
                      setFieldValue(
                        'organisation_type',
                        option !== undefined ? option : null,
                      )
                    }
                    error={
                      touched.organisation_type && errors.organisation_type
                    }
                    hidden={true}
                    disabled={true}
                  />

                  <MakeField
                    value={values.make}
                    hidden={true}
                    disabled={true}
                  />

                  <DisabledField
                    options={disabledOptions}
                    onChange={(option) => setFieldValue('disabled', option)}
                    value={values.disabled}
                    disabled={!editRights}
                  />

                  <Buttons
                    isSaving={isSaving}
                    values={values}
                    onSubmit={this.requestUserEdition}
                    savingDisabled={!editRights || !dirty}
                  />
                </Flex>
              </form>
            )
          }}
        </Formik>
      </Flex>
    )
  }
}

export default injectIntl(EditUser)
